import React from 'react'
import Table from '../../../components/Table/Table'
import useInventory from '../hook/useInventory'
import { inventoryList } from '../../../repository/taskRepo'
import { Pagination } from '../../../components/pagination/Pagination'
import moment from 'moment'

const Index = () => {
    const { data, methods } = useInventory()
    const {
        stockData,
        inventoryData,
        stockDetails,
        totalCount,
        controller,
        Count
    } = data
    const {
        setStockData,
        AddUpdateStock,
        handlePagination
    } = methods
    const TableHead = [
        { label: 'Quantity', id: '' },
        // { label: "Name", id: "" },
        // { label: "Group", id: "" },
        { label: 'Date/Time', id: '' },

        { label: 'Action', id: '' },
        // { label: 'Status', id: '' },
        // { label: 'Resolved', id: '' },
        // { label: 'Resolve/Closed', id: '' },
    ]
    console.log("inventoryData",inventoryData)
    return (
        <div className='contact'>
            <div className='container bg'>
                <div className="row">
                    <div className="col-lg-12 pt-4">
                        <div className="col-lg-12 pt-4 mt-2 ms-4">
                            <div className="row my-3">
                                <div className="col-lg-6">
                                    <p className=""><span className="fw-bold">Name :</span> <span className="text-muted">{inventoryData?.productName}</span></p>
                                    {/* <p className=""><span className="fw-bold">Emails :</span> <span className="text-muted">emily.garcia@freshdesk.com</span></p> */}
                                    <p className=""><span className="fw-bold">Category :</span> <span className="text-muted">{inventoryData?.category}</span></p>
                                    {/* <p className=""><span className="fw-bold">Channel :</span> <span className="text-muted">{projectInputs?.channel ? projectInputs?.channel : "--"}</span></p> */}
                                    <p className=""><span className="fw-bold">Vendor :</span> <span className="text-muted">{inventoryData?.vendor || "-"}</span></p>
                                    <p className=""><span className="fw-bold">Purchase Price: </span> <span className="text-muted"></span>{inventoryData?.purchasePrice}</p>

                                </div>
                                <div className="col-lg-6 pe-5">
                                    <p className=""><span className="fw-bold">Stock Quantity :</span > <span className="text-muted" />
                                        {inventoryData?.stockQuantity || "-"}
                                    </p>
                                    <p className=""><span className="fw-bold">Brand/Manufacture :</span> <span className="text-muted">
                                    </span>
                                        {inventoryData?.brand || "-"}</p>
                                    <p className=""><span className="fw-bold">Re-Order :</span> <span className="text-muted">
                                    </span>{
                                            inventoryData?.reorderLevel || "-"
                                        }</p>
                                    <p className=""><span className="fw-bold">MRP :</span> <span className="text-muted">
                                    </span>{inventoryData?.mrp || "-"}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container bg">
                <div className="col-lg-12 mt-5">
                    <div className="bg shadow raduus ">
                        <div className="">
                            <div className="">
                                <table className="table text-center">
                                    <Table
                                        className="text-center"
                                        TableHeadData={TableHead}
                                        // numberOfSelected={numberOfSelected}
                                        rowCount={TableHead?.length}
                                    // onSelectAllClick={onSelectAllClick}
                                    />

                                    <tbody>
                                        {Array.isArray(stockDetails) && stockDetails.length > 0 ? (
                                            stockDetails.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item?.quantity}</td>
                                                    <td>
                                                        {item?.createdAt
                                                            ? moment(item.createdAt).format('MMMM D, YYYY [at] hh:mm:ss A')
                                                            : '-'}
                                                    </td>
                                                    <td>{item?.action}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2"
                                                    className='text-center p-3'
                                                >No record found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {/* {!ticketList?.length && <div className="text-center">No record found</div>} */}
                                {
                                    stockDetails?.length > 10 && (
                                        <Pagination count={Count} controller={controller} setController={handlePagination} />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index
